import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getAllUserInstallations } from '../api/Installation';
import {
  Installation,
  InstallationsResponse,
  FetchInstallationsArgs,
  InstallationState,
} from '../types/instalationsTypes';

const initialState: InstallationState = {
  installations: [],
  loading: false,
  error: null,
};
export const fetchInstallations = createAsyncThunk<
  InstallationsResponse,
  FetchInstallationsArgs,
  { rejectValue: string }
>('installation/fetchInstallations', async ({ cognitoId, token }, { rejectWithValue }) => {
  try {
    const data = await getAllUserInstallations(cognitoId, token);
    return data;
  } catch (err) {
    if (err instanceof Error) {
      return rejectWithValue(err.message);
    } else {
      return rejectWithValue('An unknown error occurred');
    }
  }
});

const installationSlice = createSlice({
  name: 'installation',
  initialState,
  reducers: {
    resetInstallationState: (state) => {
      state.installations = initialState.installations;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInstallations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInstallations.fulfilled, (state, action: PayloadAction<Installation[]>) => {
        state.loading = false;
        state.installations = action.payload;
      })
      .addCase(fetchInstallations.rejected, (state, action: PayloadAction<string | undefined>) => {
        state.loading = false;
        state.error = action.payload || 'An unknown error occurred';
        console.error('Error in fetchInstallations:', state.error);
      });
  },
});

export const { resetInstallationState } = installationSlice.actions;
export default installationSlice.reducer;
